import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-d088370c");

_pushScopeId("data-v-d088370c");

var _hoisted_1 = {
  class: "tab-header"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Poročanje");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Pogodbe");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Nastavitve");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Administracija");

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache) {
  var _ctx$$user;

  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createBlock("nav", _hoisted_1, [_createVNode("div", {
    class: {
      active: _ctx.$route.fullPath.indexOf('/porocanja') === 0
    }
  }, [_createVNode(_component_router_link, {
    tag: "div",
    to: {
      name: 'reportList'
    }
  }, {
    default: _withId(function () {
      return [_hoisted_2];
    }),
    _: 1
  })], 2), _createVNode("div", {
    class: {
      active: _ctx.$route.fullPath.indexOf('/pogodbe') === 0
    }
  }, [_createVNode(_component_router_link, {
    to: {
      name: 'contractList'
    }
  }, {
    default: _withId(function () {
      return [_hoisted_3];
    }),
    _: 1
  })], 2), _createVNode("div", {
    class: {
      active: _ctx.$route.fullPath.indexOf('/nastavitve') === 0
    }
  }, [_createVNode(_component_router_link, {
    to: {
      name: 'userProfile'
    }
  }, {
    default: _withId(function () {
      return [_hoisted_4];
    }),
    _: 1
  })], 2), (_ctx$$user = _ctx.$user) !== null && _ctx$$user !== void 0 && _ctx$$user.admin ? (_openBlock(), _createBlock("div", {
    key: 0,
    class: {
      active: _ctx.$route.fullPath.indexOf('/admin') === 0
    }
  }, [_createVNode(_component_router_link, {
    to: {
      name: 'adminUserList'
    }
  }, {
    default: _withId(function () {
      return [_hoisted_5];
    }),
    _: 1
  })], 2)) : _createCommentVNode("", true)]);
});